import { PaginationTypes } from '../types';

export const usePaginatedData = <T>(data: T[], pagination: PaginationTypes) => {
    const startIndex = pagination.pageSize * pagination.pageIndex;
    const endIndex = startIndex + pagination.pageSize;

    return {
        data: data.slice(startIndex, endIndex),
        totalRowCount: data.length,
    };
};
